import { StorageOfferResource } from 'app/storage-offer/storage-offer.resource';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import * as angular from 'angular';
import { Decimal } from 'decimal.js';

class UpdateStorageOfferBidComponentCtrl implements ng.IController {
    public offer: StorageOfferDto;
    public editBidId: number;
    public updateSuccess: boolean = false;
    public offerBid: StorageOfferBidDto;
    public offerUpdateBid: StorageOfferUpdateBidDto;
    public submitPending: boolean = false;
    private formDisabled: boolean = false;
    public updateBidForm;
    public minQuantitiesForDisabledForm: string[] = [];
    public maxQuantitiesForDisabledForm: string[] = [];
    public priceAmountsForDisabledForm: string[] = [];

    constructor(
        private readonly $filter: ng.IFilterService,
        private $location: ng.ILocationService,
        private storageOfferResource: StorageOfferResource,
        private errorHandler: ErrorHandler,
        private $anchorScroll: ng.IAnchorScrollService
    ) {}

    $onInit(): void {
        this.offerUpdateBid = {
            productBids: angular.copy(this.offerBid.productBids)
        } as StorageOfferUpdateBidDto;
        this.offerUpdateBid.id = this.offerBid.id;
    }

    public modifyBid() {
        this.formDisabled = false;
    }

    public updateBid(form: ng.IFormController): boolean {
        if (!form.$valid) {
            return false;
        }

        if (!this.formDisabled) {
            this.offerUpdateBid.productBids.forEach((offerBid, index) => {
                offerBid.minQuantityValue = offerBid.minQuantityValue || 0;
                offerBid.maxQuantityValue = offerBid.maxQuantityValue || 0;
                offerBid.priceAmount = offerBid.priceAmount || {
                    value: '0',
                    floatingPointNumber: true
                };
                this.setDisabledValueForMinQuantity(index);
                this.setDisabledValueForMaxQuantity(index);
                this.setDisabledValueForPriceAmount(index);
            });
            this.formDisabled = true;
            this.goToUpdateBidSection();
            return false;
        }

        this.submitPending = true;

        this.storageOfferResource
            .updateBid(
                { id: this.offer.id },
                this.offerUpdateBid,
                (res: StorageOfferUpdateBidDto) => {
                    this.offerBid.productBids = angular.copy(
                        this.offerUpdateBid.productBids
                    );
                    this.updateBidForm.$setUntouched();
                    this.updateBidForm.$setPristine();
                    this.updateSuccess = true;
                    this.editBidId = null;
                    this.$location.url(this.$location.path());
                },
                (err: any) => {
                    this.errorHandler(err);
                }
            )
            .$promise.finally(() => {
                this.submitPending = false;
                this.formDisabled = false;
            });

        return true;
    }

    public goToUpdateBidSection(): void {
        this.$anchorScroll(this.offerBid.id.toString());
    }

    public setDisabledValueForMinQuantity(i: number) {
        const minQuantityValue =
            this.offerUpdateBid.productBids[i].minQuantityValue;
        this.minQuantitiesForDisabledForm[i] =
            this.$filter('number')(minQuantityValue);
    }

    public setDisabledValueForMaxQuantity(i: number) {
        const maxQuantityValue =
            this.offerUpdateBid.productBids[i].maxQuantityValue;
        this.maxQuantitiesForDisabledForm[i] =
            this.$filter('number')(maxQuantityValue);
    }

    public setDisabledValueForPriceAmount(i: number) {
        if (!this.offerUpdateBid.productBids[i].priceAmount) return;
        const priceAmount =
            this.offerUpdateBid.productBids[i].priceAmount.value;
        this.priceAmountsForDisabledForm[i] = this.$filter('number')(
            '' + priceAmount,
            this.getDecimalPlaces(priceAmount)
        );
    }

    public getDecimalPlaces(value: Decimal | string): number {
        if (value instanceof Decimal) {
            return value.decimalPlaces();
        } else {
            return new Decimal(value).decimalPlaces();
        }
    }

    public cancelUpdateBid() {
        this.editBidId = null;
        this.$location.url(this.$location.path());
    }
}

angular.module('app').component('pkpUpdateStorageOfferBid', {
    controller: UpdateStorageOfferBidComponentCtrl,
    template:
        require('app/storage-offer-bid/update-storage-offer-bid.component.html'),
    bindings: {
        offerBid: '=',
        offer: '<',
        editBidId: '='
    }
});
